import { ILanguagesResponse } from 'types/language';
import request from './index';

export const getLanguages = () =>
  request<ILanguagesResponse>({
    options: {
      url: '/languages',
      method: 'get'
    }
  });
